import { createApi } from '@reduxjs/toolkit/query/react';
import { GenericResponse, IResetPasswordRequest } from '@/redux/models';
import customFetchBase from './customFetchBase';
import { RegisterInput } from '../../components/Auth/RegisterForm';



export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    registerUser: builder.mutation<GenericResponse, RegisterInput>({
      query(data) {
        return {
          url: 'auth/register',
          method: 'POST',
          body: data,
        };
      },
    }),
    loginUser: builder.mutation<GenericResponse,  any>({
      query(data) {
        return {
          url: 'auth/login',
          method: 'POST',
          body: data,
          credentials: 'include',
        };
      },
    }),
    logoutUser: builder.mutation<void, void>({
      query() {
        return {
          url: 'auth/logout',
          credentials: 'include',
        };
      },
    }),
    verifyEmail: builder.mutation<GenericResponse, string>({
      query(verificationCode) {
        return {
          url: `auth/verifyemail/${verificationCode}`,
          credentials: 'include',
        };
      },
    }),
    forgotPassword: builder.mutation<GenericResponse, string>({
      query(email) {
        return {
          url: `auth/forgotpassword/`,
          method: 'PUT',
          credentials: 'include',
          params: { email },
        };
      },
    }),
    resetPassword: builder.mutation<GenericResponse, IResetPasswordRequest>({
      query(params) {
        return {
          url: `auth/updatepassword`,
          method: 'POST',
          body: params,
          credentials: 'include',
        };
      },
    }),
    verifyAccount: builder.query<GenericResponse, string>({
      query(code) {
        return {
          url: `auth/verifyAccount?validationToken=${code}`,
          method: 'PUT',
          credentials: 'include',
        };
      },
    }),
    verifyToken: builder.query<GenericResponse, string>({
      query(token) {
        return {
          url: `auth/verificarToken?token=${token}`,
          method: 'GET',
          credentials: 'include',
        };
      },
    }),
  }),
});

export const {
  useLoginUserMutation,
  useRegisterUserMutation,
  useLogoutUserMutation,
  useVerifyEmailMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyAccountQuery,
  useVerifyTokenQuery,
} = authApi;
